import CommonDialog from 'components/modals/CommonDialog'
import { FC } from 'react'
import ModalButtons from '../ModalButtons'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import CommonFormField from 'components/form/CommonFormField'

type CmpProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const expectedValue = 'DELETE'

const schema = z.object({
  value: z.string().refine((value) => value.trim() === expectedValue, {
    message: 'Value is not correct',
  }),
})

const DeleteConfirmationModal: FC<CmpProps> = ({
  open,
  onClose,
  onConfirm,
}: CmpProps) => {
  const form = useForm({
    defaultValues: {
      value: '',
    },
    resolver: zodResolver(schema),
  })

  const handleClose = () => {
    form.reset()
    onClose()
  }

  const handleConfirm = () => {
    void onConfirm()
    form.reset()
  }

  return (
    <CommonDialog
      open={open}
      onCloseModal={handleClose}
      title="Delete user profile"
      className="max-w-[460px]"
    >
      <p className="mb-xxs text-sm font-medium text-gray-900">
        Type <i className="font-normal">{expectedValue}</i> to delete user and
        all related data
      </p>
      <FormProvider {...form}>
        <CommonFormField name="value" control={form.control} className="mb-m" />

        <ModalButtons
          onCancel={handleClose}
          onConfirm={handleConfirm}
          isSubmitDisabled={!form.formState.isValid}
          className="!p-0"
        />
      </FormProvider>
    </CommonDialog>
  )
}

export default DeleteConfirmationModal
